<template>
  <div :class="[`sc-city-title ${$mq}`]">
    <r-icon :name="iconName" :size="24" />
    <r-title type="title-1" colorType="secondary">{{ $t(city) }}</r-title>
  </div>
</template>

<script>
const cityList = [
  "moscow",
  "chelyabinsk",
  "nizhny tagil",
  "tomsk",
  "saint petersburg"
];

export default {
  props: {
    city: {
      type: String,
      validator: val => cityList.indexOf(val) !== -1,
      default: "moscow"
    }
  },
  computed: {
    iconName() {
      switch (this.city) {
        case "chelyabinsk":
          return "chelyabinsk";
        default:
          return "s-center";
      }
    }
  }
};
</script>

<style lang="scss">
.sc-city-title {
  position: relative;
  display: flex;
  align-items: center;
  border-bottom: 1px solid;
  border-color: var(--dividers_low_contrast) !important;
  padding-bottom: 8px;
  > div {
    margin-right: 6px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "moscow": "Москва",
    "chelyabinsk": "Челябинск",
    "nizhny tagil": "Нижний Тагил",
    "tomsk": "Томск",
    "saint petersburg": "Санкт-Петербург"
  },
  "en": {
    "moscow": "Moscow",
    "chelyabinsk": "Chelyabinsk",
    "nizhny tagil": "Nizhny Tagil",
    "tomsk": "Tomsk",
    "saint petersburg": "Saint Petersburg"
  }
}
</i18n>
